/**
 * Validation utilities for preventing duplicate check-ins
 */

import { getCurrentPeriod } from './time.js';

/**
 * Check if the current period has already been logged
 * Prevents double-logging the same pomodoro
 */
export async function canLogCurrentPeriod(
  db: any,
  now: Date = new Date()
): Promise<boolean> {
  const currentPeriod = getCurrentPeriod(now);

  try {
    // Query for any check-in with matching currentPeriod.start timestamp
    const result = await db.find({
      selector: {
        type: 'check-in',
        'currentPeriod.start': currentPeriod.start.getTime()
      },
      limit: 1
    });

    // Can log if no existing entry found
    return result.docs.length === 0;
  } catch (error) {
    console.error('Error checking for duplicate period:', error);
    // Allow logging if query fails (better to allow than block)
    return true;
  }
}

/**
 * Validate check-in data before submission
 */
export function validateCheckInData(data: {
  pastDescription: string;
  futureDescription: string;
}): { valid: boolean; errors: string[] } {
  const errors: string[] = [];

  if (!data.pastDescription || data.pastDescription.trim().length === 0) {
    errors.push('Past description is required');
  }

  if (!data.futureDescription || data.futureDescription.trim().length === 0) {
    errors.push('Future description is required');
  }

  return {
    valid: errors.length === 0,
    errors
  };
}
